import React from 'react';
import { useTranslation } from 'react-i18next';
import { Award, Target, Users, Leaf } from 'lucide-react';
import { Card, CardContent } from './ui/card';

const iconMap = {
  'quality': Award,
  'innovation': Target,
  'commitment': Users,
  'sustainability': Leaf
};

const About = () => {
  const { t } = useTranslation();

  const values = ['quality', 'innovation', 'commitment', 'sustainability'];

  return (
    <section className="py-20 bg-white">
      <div className="container mx-auto px-4">
        {/* Header */}
        <div className="max-w-3xl mx-auto text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold text-foreground mb-4">
            {t('about.title')}
          </h2>
          <p className="text-xl text-primary font-semibold">
            {t('about.subtitle')}
          </p>
        </div>

        {/* Content */}
        <div className="max-w-4xl mx-auto mb-16">
          <p className="text-lg text-muted-foreground leading-relaxed mb-6 text-justify">
            {t('about.content1')}
          </p>
          <p className="text-lg text-muted-foreground leading-relaxed mb-6 text-justify">
            {t('about.content2')}
          </p>
          <p className="text-lg text-muted-foreground leading-relaxed mb-6 text-justify">
            {t('about.content3')}
          </p>
        </div>

        {/* Values */}
        <div className="max-w-6xl mx-auto">
          <h3 className="text-3xl font-bold text-center text-foreground mb-12">
            {t('about.valuesTitle')}
          </h3>
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
            {values.map((value, index) => {
              const Icon = iconMap[value];
              return (
                <Card
                  key={value}
                  className="border-2 hover:border-primary transition-all duration-300 hover:shadow-lg group"
                >
                  <CardContent className="p-6 text-center">
                    <div className="w-16 h-16 mx-auto mb-4 bg-primary/10 rounded-full flex items-center justify-center group-hover:bg-primary transition-colors duration-300">
                      <Icon className="w-8 h-8 text-primary group-hover:text-white transition-colors duration-300" />
                    </div>
                    <h4 className="text-xl font-bold text-foreground mb-3">
                      {t(`about.values.${value}.title`)}
                    </h4>
                    <p className="text-muted-foreground">
                      {t(`about.values.${value}.description`)}
                    </p>
                  </CardContent>
                </Card>
              );
            })}
          </div>
        </div>
      </div>
    </section>
  );
};

export default About;
